<template>
  <accordion-item-fi
    v-if="catalogData?.PerformanceDataAttributes"
    class="accordion-performance-data-fi"
    header-tag="h3"
    ignore-others
    scroll-to
  >
    <template #header>
      {{ $dict.get('product-Catalog.Accordions.Performance-Data.Label') }}
    </template>
    <template #content>
      <grid-columns-fi
        :columns="12"
        grid-class="lg:fi-grid-cols-10"
      >
        <div class="fi-col-span-full md:fi-col-span-6 lg:fi-col-span-5">
          <technical-details-table-fi
            v-if="catalogData"
            :item="{ catalogProductData: catalogData }"
            source="PerformanceDataAttributes"
          />
        </div>
      </grid-columns-fi>
    </template>
  </accordion-item-fi>
</template>

<script setup lang="ts">
import { AccordionItemFi } from 'atoms';

import GridColumnsFi from '@/components/grid-fi/GridColumnsFi.vue';
import TechnicalDetailsTableFi from '@/components/shop-modules/technical-details-table-fi/TechnicalDetailsTableFi.vue';
import type { CatalogProductData } from '@/generated/graphql';
defineProps<{
  catalogData: CatalogProductData;
}>();
</script>

<style scoped src="./accordion-performance-data-fi" />
